import axios from "axios";
import _ from "lodash";
import Endpoint, { ENDPOINT } from "../../constants/endpoint";

const state = {
  loading: false,
  error: {},
  data: [],
  focusId: null,
};

const getters = {
  // foods: state => state.foods
};

const actions = {
  // action
  getVessel(context, payload) {
    const url = ENDPOINT.RTS_VESSEL;
    context.commit("LOADING", { loading: true });
    const type = payload.type;
    let config = {
      headers:{
        "X-User-Email": "anuwat@outputstream.net",
        "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
      },
      params: {
        icon_type: "EXCISE"
      }
    };
    axios
      .get(url,config)
      .then((res) => {
        const vessel = _.get(res, "data", []);
        const data = _.filter(vessel, { icon_type: type });
        if (data.length > 0) {
          context.commit("SUCCESS", { data });
        }
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  panTo(context, id) {
    context.commit("PANTO", { id });
  },
};

const mutations = {
  PANTO(state, payload) {
    state.focusId = payload.id;
  },
  UPDATE(state, payload) {
    state.data = {
      ...payload,
      ...state.data,
    };
  },
  SUCCESS(state, payload) {
    state.data = payload.data;
  },
  ERROR(state, payload) {
    state.error = {
      ...payload,
    };
  },
  LOADING(state, payload) {
    state.loading = payload.loading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
